import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'pc-image-banner',
  standalone: true,
  imports: [],
  templateUrl: './image-banner.component.html',
  styleUrl: './image-banner.component.scss'
})
export class ImageBannerComponent implements OnInit {
  @Input() imgUrl: string = '';
  @Input() altText: string = '';
  @Input() simpleImage: boolean = false;

  ngOnInit(): void {

  }
}
